module.exports = __webpack_public_path__ + "img/e.2badadc0.jpg";